import React from 'react';
import {
    Alert,
    FormControl,
    FormControlLabel,
    Grid,
    InputLabel, MenuItem,
    Select,
    Switch,
    TextField,
    Typography
} from "@mui/material";
import * as Yup from 'yup';
import useAuth from "../../../hooks/useAuth";
import GeneralEditor, {MODE_CREATE, MODE_EDIT} from "../../../components/CrudFrom/GeneralEditor";
import {executeMutationUtil, executeQueryUtil} from "../../../utils/gqlUtil";
import localStrings from "../../../localStrings";
import {useNavigate} from "react-router";
import {addDataBrandToCache, createBrandMutation, updateBrandMutation} from "../../../gql/BrandGql";
import {updateProductUserMutation} from "../../../gql/productUserGql";
import {updateBrandAdminMutation} from "../../../gql/BrandAdminGql";
import {uuid} from "uuidv4";
import TextFieldPassword from "../../../components/TextFieldPassword";
import TextFieldWithCopy from "../../../components/TextFieldWithCopy";
import useAppUtil from "../../../hooks/useAppUtil";
import {dashboardBaseRoute} from "../../../routes/dashboard";

const countryCodes = require('country-codes-list')
const myCountryCodesObject = countryCodes.customList('countryCode', '[{countryCode}] {countryNameEn}: +{countryCallingCode}')


const BrandCreateUpdateForm = ({className, modeEdit}) => {
    const { currentBrand, setBrand, userInDb, superAdmin, user } = useAuth();
    const { addError } = useAppUtil();
    const navigate = useNavigate();

    function getMutationFunction() {
        if (superAdmin) {
            return updateBrandAdminMutation
        }
        return updateBrandMutation;
    }

    const saveForm = async (values) => {

        if (!superAdmin && modeEdit === MODE_CREATE) {
            addError(localStrings.error.needSuperUser);
            return;
        }

        if (!values.authKey || values.authKey === "") {
            values.authKey = uuid();
        }

        delete values.brandId;
        if (!superAdmin || modeEdit === MODE_CREATE) {
            delete values.credit;
            delete values.minimalCreditToLock;
            delete values.blockWhenInsufficientCredit;
            delete values.useChargeOnline;
        }
        if (!currentBrand() || modeEdit == MODE_CREATE) {
            let res = await executeMutationUtil(createBrandMutation(values));
            await setBrand(res.data.addBrand);
            if (!currentBrand()) {
                await executeMutationUtil(updateProductUserMutation({
                    ...userInDb,
                    brandId: res.data.addBrand.id
                }));
                await setBrand(res.data.addBrand);
            }
            if (modeEdit == MODE_CREATE) {
                await addDataBrandToCache([res.data?.addBrand]);
            }
            navigate('/' + dashboardBaseRoute, { replace: true });
        }
        else {
            let res = await executeMutationUtil(getMutationFunction()(
                    {
                        ...values,
                        minimalCreditToLock: parseInt(values.minimalCreditToLock),
                        credit: parseInt(values.credit),
                        id: currentBrand().id,
                    }
                )
            );
            await setBrand(superAdmin ? res.data.updateBrandAdmin : res.data.updateBrand);
            if (superAdmin) {
                return res.data.updateBrandAdmin
            }
            else {
                return res.data.updateBrand
            }

            // enqueueSnackbarWithSound(toast, null, null,
            //   localStrings.notif.brandUpdated);
        }

    }

    const DEFAULT_PROJECT_ID = "totemsystem-5889b";

    const buildFormValues = (item) => {
        return {
            initialValues: {
                brandName: item.brandName || '',
                brandId: currentBrand()?.id,
                contactEmail: item.contactEmail || userInDb?.email || '',
                country : item.country || '',
                credit: item.credit || '0',
                minimalCreditToLock: item.minimalCreditToLock || '0',
                blockWhenInsufficientCredit: item.blockWhenInsufficientCredit || false,
                // loggingProjectId: item.loggingProjectId || '',
                authKey: item.authKey || '',
                // useChargeOnline: item.useChargeOnline
            },
            validationSchema: {
                brandName: Yup.string().max(255).required(localStrings.check.fieldRequired),
                contactEmail: Yup.string().email(localStrings.check.badEmailFormat).required(localStrings.check.fieldRequired),
            }
        };
    }

    const getCardContentForm = ({
                                    errors,
                                    handleBlur,
                                    handleChange,
                                    handleSubmit,
                                    isSubmitting,
                                    setFieldValue,
                                    touched,
                                    values
                                }) => {
        return (
            <Grid
                container
                spacing={4}
            >
                <Grid
                    item
                    md={12}
                    xs={12}
                >
                    <TextField
                        inputProps={{
                            autocomplete:"new-password"
                        }}
                        error={Boolean(touched.brandName && errors.brandName)}
                        fullWidth
                        helperText={touched.brandName && errors.brandName}
                        label={localStrings.brandName}
                        name="brandName"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        variant="standard"
                        required
                        value={values.brandName}
                    />
                </Grid>

                {currentBrand() &&
                    <Grid
                        item
                        md={12}
                        xs={12}
                    >
                        <TextFieldWithCopy
                            inputProps={{
                                autocomplete: "new-password"
                            }}
                            variant="standard"
                            error={Boolean(touched.brandId && errors.brandId)}
                            fullWidth
                            helperText={touched.brandId && errors.brandId}
                            label={localStrings.brandId}
                            name="brandId"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            disabled

                            value={values.brandId}
                        />
                    </Grid>
                }


                {currentBrand() &&
                    <Grid
                        item
                        md={12}
                        xs={12}
                    >
                        <TextFieldPassword
                            variant="standard"
                            inputProps={{
                                autocomplete: "new-password"
                            }}
                            error={Boolean(touched.authKey && errors.authKey)}
                            fullWidth
                            helperText={touched.authKey && errors.authKey}
                            label={localStrings.authKey}
                            name="authKey"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            disabled
                            value={values.authKey}
                        />
                    </Grid>
                }

                <Grid
                    item
                    md={12}
                    xs={12}
                >
                    <TextField
                        inputProps={{
                            autocomplete:"new-password"
                        }}
                        variant="standard"
                        error={Boolean(touched.contactEmail && errors.contactEmail)}
                        fullWidth
                        helperText={touched.contactEmail && errors.contactEmail}
                        label={localStrings.contactEmail}
                        name="contactEmail"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        required
                        value={values.contactEmail}
                    />
                </Grid>



                <Grid
                    item
                    md={12}
                    xs={12}
                >

                    <FormControl fullWidth>
                        <InputLabel>{localStrings.countryCode}</InputLabel>
                        <Select
                            variant="standard"
                            value={values.country}
                            label="Age"
                            onChange={(event) => setFieldValue('country', event.target.value)}
                        >
                            {Object.keys(myCountryCodesObject).map(( itemKey, value) =>
                                <MenuItem value={itemKey}>{myCountryCodesObject[itemKey]}</MenuItem>
                            )}

                        </Select>
                    </FormControl>
                </Grid>


                {superAdmin && modeEdit !== MODE_CREATE &&
                    <>
                        <Grid
                            item
                            md={12}
                            xs={12}
                        >
                            <Typography>{localStrings.adminSection}</Typography>
                        </Grid>
                        <Grid
                            item
                            md={12}
                            xs={12}
                        >
                            <TextField
                                inputProps={{
                                    autocomplete:"new-password"
                                }}
                                error={Boolean(touched.credit && errors.credit)}
                                fullWidth
                                helperText={touched.credit && errors.credit}
                                label={localStrings.credits}
                                name="credit"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                required
                                variant={"filled"}
                                value={values.credit}
                            />
                        </Grid>

                        <Grid
                            item
                            md={12}
                            xs={12}
                        >
                            <TextField
                                inputProps={{
                                    autocomplete:"new-password"
                                }}
                                error={Boolean(touched.minimalCreditToLock && errors.minimalCreditToLock)}
                                fullWidth
                                helperText={touched.minimalCreditToLock && errors.minimalCreditToLock}
                                label={localStrings.minimalCreditToLock}
                                name="minimalCreditToLock"
                                variant={"filled"}
                                onBlur={handleBlur}
                                onChange={handleChange}
                                required
                                value={values.minimalCreditToLock}
                            />
                        </Grid>
                        <Grid
                            item
                            md={12}
                            xs={12}
                        >
                            <FormControlLabel
                                // className={classes.formControl}
                                control={(
                                    <Switch
                                        checked={values.blockWhenInsufficientCredit}
                                        edge="start"
                                        name="direction"
                                        onChange={() => {
                                            //alert("change ");
                                            setFieldValue('blockWhenInsufficientCredit', !values.blockWhenInsufficientCredit)
                                        }}
                                    />
                                )}
                                label={localStrings.blockWhenInsufficientCredit}
                            />
                        </Grid>

                        <Grid
                            item
                            md={12}
                            xs={12}
                        >
                            <FormControlLabel
                                // className={classes.formControl}
                                control={(
                                    <Switch
                                        checked={values.useChargeOnline}
                                        edge="start"
                                        name="direction"
                                        onChange={() => {
                                            //alert("change ");
                                            setFieldValue('useChargeOnline', !values.useChargeOnline)
                                        }}
                                    />
                                )}
                                label={localStrings.useChargeOnline}
                            />
                        </Grid>
                    </>
                }

                {/*<p>{JSON.stringify(Object.keys(myCountryCodesObject))}</p>*/}
            </Grid>
        );
    }

    return(
        <>
            <GeneralEditor getItemFunction={() => {
                if (modeEdit == MODE_CREATE) {
                    return null;
                }
                return currentBrand()
            }}
                           buildFormValues={buildFormValues}
                           getCardContentForm={getCardContentForm}
                           saveForm={async (item, values) => {
                               return await saveForm(values);
                           }}
                           applyButton={(!currentBrand() || modeEdit == MODE_CREATE) ? localStrings.create : localStrings.update}
                           messageSuccess={(!currentBrand() || modeEdit == MODE_CREATE) ?
                               localStrings.notif.brandCreated : localStrings.notif.brandUpdated}
                           titleForm={(!currentBrand() || modeEdit == MODE_CREATE) ? localStrings.createBrand : localStrings.updateBrand}
                           getPathToData={(result) => {
                               return result;
                           }}
            />
        </>
    )
};

export default BrandCreateUpdateForm;
